import React from 'react';

const SectionHeader = ({
    wrapperClassName,
    subtitleClassName,
    titleClassName,
    descriptionClassName,
    subtitle,
    title,
    description
}) => (
    <div className={wrapperClassName}>
        {subtitle ? <div className={subtitleClassName}>{subtitle}</div> : null}
        {title ? <h2 className={titleClassName}>{title}</h2> : null}
        {description ? <p className={descriptionClassName}>{description}</p> : null}
    </div>
);

export default SectionHeader;
